export default __webpack_public_path__ + "static/media/convoso.97fa5083.png";